module.exports = __webpack_public_path__ + "img/joyNoBook.692c7121.jpg";